/**
 * @author Fernando Ruano
 * @file index.js
 * @description Middlewares General
 */

// Dependencies
import promiseMiddleware from 'redux-promise';
import thunkMiddleware from 'redux-thunk';

// Define Store Middlewares as an array
export default [promiseMiddleware, thunkMiddleware];
